import { ursaColors } from "@smartsheet/design-tokens";
import * as React from "react";
import { SVGProps } from "react";

interface StatusBarIconProps extends SVGProps<SVGSVGElement> {
    value: 0 | 25 | 50 | 75 | 100;
    emptyFillColor?: string;
    fillColor?: string;
}

const SvgComponent = ({
    fillColor = ursaColors.azure400,
    emptyFillColor = ursaColors.neutral00,
    value,
    ...props
}: StatusBarIconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 20 20" {...props}>
        <circle
            cx="10"
            cy="10"
            r="6.3"
            fill={value === 100 ? fillColor : emptyFillColor}
            stroke={fillColor}
            strokeWidth="1.4"
        />
        {value === 25 ? (
            <path
                d="M16.2999 10.0529C16.2999 9.21861 16.241 8.3925 15.9218 7.62173C15.6025 6.85095 15.1346 6.15061 14.5447 5.56068C13.9548 4.97076 13.2544 4.50281 12.4837 4.18354C11.7129 3.86427 10.8869 3.69995 10.0526 3.69995L10.0526 10.0529H16.2999Z"
                fill={fillColor}
            />
        ) : value === 50 ? (
            <path d="M9.947 16.195a6.247 6.247 0 1 0 0-12.495V16.195Z" fill={fillColor} />
        ) : value === 75 ? (
            <path d="M3.7 9.947A6.248 6.248 0 1 0 9.947 3.7v6.247H3.7Z" fill={fillColor} />
        ) : (
            ``
        )}
    </svg>
);

export default SvgComponent;
